<template>
  <div class="hello">
    <div class="text-titel">预付费系统平台</div>

    <div class="box-one" style="margin-bottom: 20px">
      <div>单位:</div>
      <el-select
        v-model="recordsdata.projId"
        :remote-method="findProjectInfo"
        :loading="loading"
        filterable
        remote
        reserve-keyword
        placeholder="请选择"
      >
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.projName"
          :value="index"
        >
        </el-option>
      </el-select>
    </div>
    <div class="box-one">
      <div>设备:</div>
      <el-select
        v-model="recordsdata.devIdpk"
        :remote-method="findDeviceinfo"
        :loading="loading"
        filterable
        remote
        reserve-keyword
        placeholder="请选择"
      >
        <el-option
          v-for="(item, index) in optionsD"
          :key="index"
          :label="item.installlocation"
          :value="index"
        >
        </el-option>
      </el-select>
    </div>
    <div class="box-button">
      <el-button type="primary" round @click="themebutton">进入</el-button>
      <el-button type="primary" round @click="recordbutton">充电记录</el-button>
    </div>
  </div>
</template>
<script>
import { MessageBox } from "mint-ui";
export default {
  name: "bindDetail",
  data() {
    return {
      loading: false,
      recordsdata: {
        projId: "",
        devSysName: "",
        devIdpk: "",
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      optionsD: [],
      value: "",
      isShow: false,
      request: {
        phone: "",
        openId: "",
      },
      openId: "",
      corpId: "",
      user: {},
    };
  },
  watch: {
    "recordsdata.projId": function (newValue, oldValue) {
      this.findDeviceinfo("");
    },
  },
  mounted() {
    // this.request.openId = this.$route.query.openId;
    this.openId = this.$route.query.openId;
    this.corpId = this.$route.query.corpId;
    if (this.request.openId) {
      this.getUserInfo();
    }
    this.findProjectInfo("");
  },
  methods: {
    findDeviceinfo(keyword) {
      var _this = this;
      this.common.doActionGet(
        this.common.findDeviceinfo,
        {
          keyword: keyword,
          projId: this.options[this.recordsdata.projId].projId,
        },
        function (res) {
          console.log(res);
          if (res.code == 200) {
            _this.optionsD = res.data.list;
            _this.loading = false;
          } else if (res.code == 201) {
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "dd"
      );
    },
    findProjectInfo(keyword) {
      var _this = this;
      this.common.doActionGet(
        this.common.findProjectInfo,
        { keyword: keyword, openId: _this.openId, corpId: _this.corpId },
        function (res) {
          console.log(res);
          if (res.code == 200) {
            _this.options = res.data.list;
            _this.loading = false;
          } else if (res.code == 201) {
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "dd"
      );
    },
    recordbutton(){
      var _t = this;
        _t.$router.push({
          path: "/chargingRecorduser",
          query: {
            // name: _t.options[_t.recordsdata.projId].projName,
            // projId: _t.options[_t.recordsdata.projId].projId,
            // devIdpk: _t.optionsD[_t.recordsdata.devIdpk].devidpk,
            // devSignature: _t.optionsD[_t.recordsdata.devIdpk].devsignature,
            // installlocation:
            //   _t.optionsD[_t.recordsdata.devIdpk].installlocation,
            // openId: _t.openId,
            // corpId: _t.corpId,
          },
        });

    },
    themebutton() {
      console.log(this.optionsD[this.recordsdata.devIdpk]);
      console.log(this.options[this.recordsdata.projId]);
      if (
        this.options[this.recordsdata.projId].projId == null ||
        this.options[this.recordsdata.projId].projId == "" ||
        this.optionsD[this.recordsdata.devIdpk].devidpk == null ||
        this.optionsD[this.recordsdata.devIdpk].devidpk == ""
      ) {
        MessageBox.alert("请选择单位和设备");
      } else {
        var _t = this;
        _t.$router.push({
          path: "/deviceDetails",
          query: {
            name: _t.options[_t.recordsdata.projId].projName,
            projId: _t.options[_t.recordsdata.projId].projId,
            devIdpk: _t.optionsD[_t.recordsdata.devIdpk].devidpk,
            devSignature: _t.optionsD[_t.recordsdata.devIdpk].devsignature,
            installlocation:
              _t.optionsD[_t.recordsdata.devIdpk].installlocation,
            openId: _t.openId,
            corpId: _t.corpId,
          },
        });
      }
    },
    //调用接口查询要绑定的用户信息
    getUserInfo() {
      //如果查询到则弹出是否绑定确认框,否则提示无此账号
      var _t = this;
      this.common.doActionGet(
        this.common.bindIsOk,
        { openId: this.request.openId },
        function (res) {
          console.log(res);
          if (res.code == 200) {
            //绑定成功,跳转到详情页bindDetail,否则提示失败原因
            _t.user = res.data;
            _t.request.phone = res.data.userphone;
          } else if (res.code == 201) {
            //未绑定微信
            var query = {
              openId: _t.request.openId,
            };
            _t.$router.push({
              path: "/bindPhone",
              query: query,
            });
          } else {
            MessageBox.alert(res.msg, "ERROR");
          }
        },
        "weixin"
      );
      this.isShow = true;
    },
    unbindWeChat() {
      var _t = this;
      MessageBox.confirm("解绑后将不再接受单位设备的报警信息！")
        .then((action) => {
          _t.common.doActionGet(
            _t.common.removeBindLny,
            _t.request,
            function (res) {
              if (res.code == 200) {
                //绑定成功,跳转到详情页bindDetail,否则提示失败原因
                var query = {
                  openId: _t.request.openId,
                };
                _t.$router.push({
                  path: "/bindPhone",
                  query: query,
                });
              } else {
                MessageBox.alert(res.msg, "ERROR");
              }
            },
            "weixin"
          );
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
@import "../../../static/wechat/wechat.css";
.hello {
  height: 100%;
  padding: 0px 20px;
  margin-top: -40px;
}
.title1 {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-top: 20px;
}
.title2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 75px;
  text-align: left;
}
.tip {
  font-size: 14px;
  color: #999999;
  text-align: left;
  margin-top: 14px;
}
.btn-code {
  width: 80px;
  height: 26px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 12px;
}
.btn-gray {
  width: 100%;
  height: 40px;
  margin-top: 100px;
}
.wechat-user-logo {
  margin-top: 80px;
}
.box-one {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.text-titel {
  width: 100%;
  padding: 50px 0px;
  font-size: 30px;
}
.box-button {
  display: flex;
  justify-content: space-around;
  margin-top: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/dormitoryofficial/dormitoryofficialHome.vue